import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchTenantModules } from '@/api/modules/modulesApi';
import type { ModuleState } from '@/api/modules/modulesApi.types';
import { buildTenantModulesQueryKey } from '@/constants/queryKeys';

export function useTenantModulesQuery(
  tenantId: string
): UseQueryResult<ModuleState[], Error> {
  return useQuery({
    queryKey: buildTenantModulesQueryKey(tenantId),
    queryFn: function loadTenantModules() {
      return fetchTenantModules(tenantId);
    },
  });
}
